module.exports = __webpack_public_path__ + "img/ti.123f26b9.png";